import { render, staticRenderFns } from "./grammar-sprint-test.vue?vue&type=template&id=db24aa3a&scoped=true&"
import script from "./grammar-sprint-test.vue?vue&type=script&lang=js&"
export * from "./grammar-sprint-test.vue?vue&type=script&lang=js&"
import style0 from "./grammar-sprint-test.vue?vue&type=style&index=0&id=db24aa3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db24aa3a",
  null
  
)

export default component.exports